import React from 'react'
import { Formik, Form } from 'formik';
import { MainInput, SubmitButton } from '../../components';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../application/utils/Routes';
import services from '../../../ioc/services';
import { useDispatch, useSelector } from 'react-redux';
import { logUserIn } from '../../../application/store/actions/user';
import { useState } from 'react';
import { getFormSubmittingState } from '../../../application/store/selectors/ui';
import { setFormSubmitting } from '../../../application/store/actions/ui';
import { useEffect } from 'react';
import { getIsUserLoggedIn } from '../../../application/store/selectors/user';
import { getItemFromStorage, storeKeys } from '../../../application/utils/Storage';

function Login() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isFormSubmiting = useSelector(getFormSubmittingState);
    const isUserLoggedIn = useSelector(getIsUserLoggedIn);

    const [rememberMe, setRememberMe] = useState(false);
    const [rememberEmail] = useState(getItemFromStorage(storeKeys.useremail, false));

    useEffect(() => {
        if (isUserLoggedIn) navigate(ROUTES.DASHBOARD);

    }, [isUserLoggedIn, isFormSubmiting])

    const isEmpty = value => value.trim() == "";

    return (
        <div className="w-full max-w-lg">
            <Formik
                initialValues={{
                    email: rememberEmail ?? ''
                }}
                enableReinitialize
                onSubmit={async (values) => {
                    if (isEmpty(values.email) || isEmpty(values.passWord)) {
                        services.alert.toast.error("Please fill all fields")
                        return
                    }

                    if (rememberMe) {

                        localStorage.setItem(storeKeys.useremail, values.email);
                    }

                    dispatch(setFormSubmitting(true))
                    dispatch(logUserIn(values))

                }}>
                <Form className="flex flex-col gap-7">
                    <MainInput label="Email Address" name="email" type="email" placeholder="User@username.com" />
                    <MainInput label="Password" name="passWord" type="password" placeholder="***************" />
                    <div className=' col-span-2 flex justify-center'>
                        <input type="checkbox" className='mr-6' id='super-check' onChange={(e) => {
                            setRememberMe(e.target.checked)
                        }} />
                        <label className="text-sm font-semibold text-gray-500" htmlFor='super-check'>Remember me</label>
                    </div>
                    <SubmitButton text="Login" disabled={isFormSubmiting} />
                </Form>

            </Formik>



        </div>
    )
}

export default Login